/**
 * AppStickSection tree:
 */

import { FC, ReactNode } from "react"
import { MainContainer, Title } from "./AppStickSection.styles"

export interface AppStickSectionProps {
  title: ReactNode | string
}

const AppStickSection: FC<AppStickSectionProps> = ({ title }) => {
  /**
   * External Hooks
   * ______________________________________________________________________________
   */

  /**
   * Consts and Variables
   * _______________________________________________________________________________
   */

  /**
   * States and Effects and Hooks
   * _______________________________________________________________________________
   */

  /**
   * Methods
   * _______________________________________________________________________________
   */

  // Check if children is a string
  const isString = (str: any): str is string => {
    return typeof str === "string"
  }

  /**
   * Template
   * _______________________________________________________________________________
   */
  return (
    <MainContainer>
      {isString(title) ? (
        <Title fontSize={16} fontWeight={"bold"}>
          - {title} -
        </Title>
      ) : (
        title
      )}
    </MainContainer>
  )
}

export default AppStickSection
